import { injectable } from 'inversify';
import { OrgRepository } from './Org.repository';

@injectable()
export class OrgService {
  protected orgRepo = new OrgRepository();

  get() {
    return this.orgRepo.get();
  }
}
